import { GridColumnWidth } from "../types/table";
export const BASE_EIGHT = 8;
export const getBasePixelSizing = (value) => `${BASE_EIGHT * value}px`;
export const COL_PIXEL_MAP = new Map([
    [GridColumnWidth.XS, getBasePixelSizing(6)],
    [GridColumnWidth.SM, getBasePixelSizing(12)],
    [GridColumnWidth.MD, getBasePixelSizing(16)],
    [GridColumnWidth.LG, getBasePixelSizing(21)],
    [GridColumnWidth.XL, getBasePixelSizing(34)],
    [GridColumnWidth.XXL, getBasePixelSizing(41)],
    [GridColumnWidth.ThreeXL, getBasePixelSizing(48)],
    [GridColumnWidth.FourXL, getBasePixelSizing(56)],
    [GridColumnWidth.FiveXL, getBasePixelSizing(66)],
    [GridColumnWidth.AUTO, "auto"],
    [GridColumnWidth.Fragment, "1fr"],
]);
